import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import classNames from 'classnames'
import moment from 'moment'

import { selectedDateEvents, selectedDateSessions } from '../../../../../reducers/studentDashboardReducer'
import { confirmAttendance } from '../../../../../actions/seriesEnrollmentActions'
import { getScheduleSessionsByMonth } from '../../../../../actions/scheduleSessionActions'
import { getEvent } from '../../../../../actions/eventActions'
import { setSelectedDate, setSelectedMonthDate } from '../../../../../reducers/studentDashboardReducer'
import { getEventsByMonth } from '../../../../../actions/eventActions'
import { ReactComponent as InfoIcon } from '../../../../../assets/images/common/icons/info-circle-icon-dark.svg'

import SessionCard from './SessionCard'
import EventCard from './EventCard'
import EmptySchedule from './EmptySchedule'
import RSVPModal from './RSVPModal'

import classes from './Schedule.module.scss'
import { Namespaces } from '../../../../../utility/namespacingHelper'

const Schedule = ({ className }) => {
  const [selectedEvent, setSelectedEvent] = useState(null)
  const { sessionsByMonth, selectedDate, eventsByMonth, selectedMonthDate, activeCourses } = useSelector(state => state.studentDashboard)
  const events = useSelector(selectedDateEvents)
  const sessions = useSelector(selectedDateSessions)
  const currentUser = useSelector(state => state.user.current_user)
  const params = useParams()

  const dispatch = useDispatch()
  const noPrograms = activeCourses?.length === 0

  useEffect(() => {
    dispatch(getEvent(params.eventId)).unwrap().then((res) => {
      dispatch(setSelectedDate(new Date(res.event.eventDate)))
      dispatch(setSelectedMonthDate(new Date(res.event.eventDate)))
    })
  }, [dispatch, params.eventId])

  useEffect(() => {
    const namespace = currentUser.family_admin && Namespaces.FAMILY_ADMIN
    if (!sessionsByMonth[selectedMonthDate.getMonth()] && !eventsByMonth[selectedMonthDate.getMonth()]) {
      dispatch(getScheduleSessionsByMonth({ selectedMonthDate, namespace }))
      dispatch(getEventsByMonth({ selectedMonthDate, namespace }))
    }
  }, [selectedMonthDate, dispatch, eventsByMonth, sessionsByMonth, currentUser])


  const getScheduleTitle = () => {
    if (new Date().toDateString() === selectedDate.toDateString()){
      return 'Today\'s Schedule'
    } else {
      return `${moment(selectedDate).format('MMMM Do')} Schedule`
    }
  }

  const handleRSVP = (data) => {
    dispatch(confirmAttendance(data)).unwrap()
      .then(setSelectedEvent(null))
      .catch(() => {
        toast.error('Something went wrong. The RSVP status has not been updated.', { position: toast.POSITION.BOTTOM_LEFT })
      })
  }

  return (
    <>
      <div className={classNames(classes.schedule, { [className]: className })}>
        <div className={classes.scheduleTitle}>
          <p className={classes.scheduleTitleText}>{getScheduleTitle()}</p>
          <InfoIcon data-for='infoTooltip' data-tip/>
          <ReactTooltip id='infoTooltip'
            effect='solid'
            delayUpdate={5}
            delayHide={5}
            place={'top'}
            className={classes.infoTooltip}
          ><p>Browse your calendar to see upcoming Programs and 9 Hole Events</p></ReactTooltip>
        </div>
        {noPrograms ?
          <EmptySchedule
            title='No Active Programs'
            text='Create a Program or a 9 Hole Event Series and Publish it to your students!'
            noActivePrograms={noPrograms}
          />
          :
          sessions.length === 0 && events.length === 0 ? (
            <EmptySchedule
              title='No Programs Today'
              text='Enjoy your time off, or explore other days in your calendar.'
            />
          ) : (
            <>
              {sessions.map((session, index) =>
                <SessionCard key={index} session={session}/>
              )}
              {events.map((e, index) =>
                <EventCard key={index} event={e} handleRSVP={() => setSelectedEvent(e)}/>
              )}
            </>
          )
        }
      </div>
      {selectedEvent &&
      <RSVPModal
        showModal={!!selectedEvent}
        closeModal={() => setSelectedEvent(null)}
        event={selectedEvent}
        onSubmit={handleRSVP}
      />
      }
    </>
  )
}

Schedule.propTypes = {
  className: PropTypes.string,
}

export default Schedule
